module.exports = __webpack_public_path__ + "img/people-group-white.a1aa40aa.png";